/*
 * @Author: Teemo Ding
 * @Date: 2021-08-06 11:33:40
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-10 14:34:19
 * @FilePath: /unifyxp-v2-store-portal/src/request/customer/databaseSettings.ts
 */
import { get, post } from 'src/tools/server';

export const request_customerDatabaseSettings = (customerDatabaseUuid) => {
  return get<any>(`/portal/customerDatabase/${customerDatabaseUuid}`, {});
};

export const request_saveCustomerDatabaseSettings = (data) => {
  return post<any>(`/portal/customerDatabase`, data, {});
};
